import { JourneyPicker } from '@features/JourneyPicker';
import { TrackGaUpdateBtnFn } from '@features/JourneyPicker/JourneyPicker.types';
import { FC } from 'react';
import { JourneyWrapper } from './AvailabilityForm.styles';
import { AvailabilityFormReduxProps } from './AvailabilityForm.types';

type AvailabilityFormProps = {
  trackGaUpdate?: TrackGaUpdateBtnFn;
};

export const AvailabilityForm: FC<AvailabilityFormReduxProps & AvailabilityFormProps> = ({
  journeyParams,
  setJourneyParams,
  changeJourneyParam,
  roomId,
  showGuestsPicker,
  trackGaUpdate,
}) => (
  <>
    <JourneyWrapper>
      <JourneyPicker
        journeyParams={journeyParams}
        showGuestsPicker={showGuestsPicker}
        roomCode={roomId}
        trackGaUpdate={trackGaUpdate}
        onChange={(params) => {
          const { fromDate, toDate, adults, childAges, children, rooms } = params;
          changeJourneyParam('fromDate', fromDate);
          changeJourneyParam('toDate', toDate);
          changeJourneyParam('spaDate', fromDate);
          changeJourneyParam(
            'adults',
            (params.rooms || []).reduce((acc, room) => acc + room.adults, 0) ?? adults
          );
          changeJourneyParam(
            'children',
            (params.rooms || []).reduce((acc, room) => acc + room.children, 0) ?? children
          );
          changeJourneyParam('rooms', rooms);
          changeJourneyParam('childAges', childAges);
          setJourneyParams(params);
        }}
        acceptPromoRateCode={true}
      />
    </JourneyWrapper>
  </>
);
